import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import Utils from '../common/Utils';
import Graphics from './utils/Graphics';

const PlayWrapper = styled.div`
    opacity: 0;
    width: 100%;
`;

const PlayField = styled.iframe`
    width: 100%;
    height: 80vh;
    border-radius: 1rem;
    background-color: lightgrey;
    padding: 0;
    margin-bottom: 2rem;
`;

export class Play extends Component {

    static propTypes = {}

    state = {
        wrapper_ref: React.createRef()
    };

    componentDidMount() {
        const {wrapper_ref} = this.state;
        Utils.animate(wrapper_ref, 1000, 0, 1, value => {
            wrapper_ref.current.style.opacity = value;
        });
    }

    menu_select = section => {
    }

    render() {
        const {wrapper_ref} = this.state;
        return <PlayWrapper ref={wrapper_ref}>
            <PlayField src={'/freq?screen=play'} />
        </PlayWrapper>
    }
}

export default Play;
